__turbopack_context__.v({
  "description": "DJl7la_description",
  "descriptionWrapper": "DJl7la_descriptionWrapper",
  "header": "DJl7la_header",
  "wrapper": "DJl7la_wrapper",
});
